export default [
    {
        path: '/incoming-goods/show/:id?',
        name: 'incoming_goods_show',
        component: () => import('@src/incoming-goods/incoming-goods-show.vue'),
        meta: {
            title: 'Wareneingang bearbeiten',
            role: 'ROLE_EDIT_INCOMING_GOODS',
            favoriteRouteName: 'incoming_goods_overview',
        },
        props({ params }: { params: { id?: string } }) {
            if (!params.id) {
                return;
            }

            return {
                id: Number(params.id),
            };
        },
    },
    {
        path: '/incoming-goods/overview',
        name: 'incoming_goods_overview',
        component: () => import('@src/incoming-goods/incoming-goods-overview.vue'),
        meta: {
            title: 'Wareneingang',
            role: 'ROLE_EDIT_INCOMING_GOODS',
        },
    },
    {
        path: '/incoming-goods/avise',
        name: 'incoming_goods_avise',
        component: () => import('@src/incoming-goods/incoming-goods-avise.vue'),
        meta: {
            title: 'Avisierungen',
            role: 'ROLE_SHOW_INCOMING_GOODS_AVISE',
        },
    },
    {
        path: '/incoming-goods/damaged-products',
        name: 'incoming_goods_damaged_products',
        component: () => import('@src/incoming-goods/damaged-products.vue'),
        meta: {
            title: 'B-Ware',
            role: 'ROLE_DAMAGED_PRODUCT_INCOMING_GOODS',
        },
    },
    {
        path: '/incoming-goods/subsequent-serial',
        name: 'incoming_goods_subsequent_serial',
        component: () => import('@src/incoming-goods/subsequent-serial.vue'),
        meta: {
            title: 'Nachgelagerter Seriennummerndruck (Virtuell)',
            role: 'ROLE_SUBSEQUENT_SERIAL_PRINT',
        },
    },
];
